module.exports = __webpack_public_path__ + "media/images/color_admin_v3/sidebar_cover-3c2599242f24e02de25c5ecdb38ddb21.jpg";